/**
 * @generated SignedSource<<270e667f4ced5263c4a78197978f8842>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DurationBasedAgendaSidebar_session$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ScheduleSwitcher_session">;
  readonly " $fragmentType": "DurationBasedAgendaSidebar_session";
};
export type DurationBasedAgendaSidebar_session$key = {
  readonly " $data"?: DurationBasedAgendaSidebar_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"DurationBasedAgendaSidebar_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DurationBasedAgendaSidebar_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ScheduleSwitcher_session"
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "24c9fc417bd54fe222f878b415059dd8";

export default node;
